import React from 'react';
import css from './home.module.scss';
import terminalCss from './terminal.module.scss';
import HeaderWhiteMask from '../../assets/images/extra/header-white-mask.png'
import Particles from "react-tsparticles";

import cg from '../../assets/images/extra/cg.png'
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import {Rating} from "@material-ui/lab";

export default class Home extends React.Component {
    emailRef = React.createRef();
    state = {nbImgToLoad: 2, open: false};
    /*
    const options={
        background: {
            color: {
                value: "#0d47a1",
            },
        },
        fpsLimit: 60,
            interactivity: {
            detectsOn: "canvas",
                events: {
                onClick: {
                    enable: true,
                        mode: "push",
                },
                onHover: {
                    enable: true,
                        mode: "repulse",
                },
                resize: true,
            },
            modes: {
                bubble: {
                    distance: 400,
                        duration: 2,
                        opacity: 0.8,
                        size: 40,
                },
                push: {
                    quantity: 4,
                },
                repulse: {
                    distance: 200,
                        duration: 0.4,
                },
            },
        },
        particles: {
            color: {
                value: "#ffffff",
            },
            links: {
                color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
            },
            collisions: {
                enable: true,
            },
            move: {
                direction: "none",
                    enable: true,
                    outMode: "bounce",
                    random: false,
                    speed: 6,
                    straight: false,
            },
            number: {
                density: {
                    enable: true,
                        value_area: 800,
                },
                value: 80,
            },
            opacity: {
                value: 0.5,
            },
            shape: {
                type: "circle",
            },
            size: {
                random: true,
                    value: 5,
            },
        },
        detectRetina: true,
    }
    */
    nbImgToLoad = 2;

    render() {
        return (
            <div className={css.homeSection} id='home'>
                <ParticlesWrapper/>
                <div className={css.section}>
                    <div>
                        <div className={terminalCss.terminal} data-terminal>
                            <span
                                data-ty="input">Hi, I am Yassin and I have an engineering degree in Computer science.</span>
                            <span data-ty="input">I am a passionate person about Web Apps in particular and Software engineering in general,
                                    I enjoy every bit of my work, was-it web design, front-end, back-end, REST APIs, extracting data,
                                    web scraping or large-scale system design...</span>
                            <span data-ty="input">I have a good instincts for debugging,
                                    and this made my personal and professional life both challenging and fun.
                                    Ever since I was an engineering student, I loved solving problems.
                                    Whether it is solo or within a team, the process of figuring things out is extremely enjoyable.</span>
                            <span data-ty="input">When I can, I like to contribute to the community by publishing
                                    code to my github account...</span>
                            <span data-ty="input">
                                    I also came to learn and appreciate a couple of things:
                                    <br/>
                                    - A healthy work environment and respect always come first.
                                    <br/>
                                    - The less I know, the more I push myself.
                                </span>
                            <span data-ty="input">Whenever I'm not at my keyboard, I enjoy reading light novels and painting.</span>
                        </div>

                        <div style={{display: 'flex', flexDirection: 'column', width: 370, alignItems: 'center', paddingTop: 40}}>
                            <div className={css.heroText}>
                                <h1 className={css.heroFullName}>Mohamed Yassine BEN KHALIFA</h1>
                                <div className={css.line}/>
                                <h1 className={css.heroTitle}>Software Engineer</h1>
                            </div>
                            <div className={css.me}/>
                            <div className={css.contact}>
                                <div>
                                    <img src="https://img.icons8.com/clouds/50/000000/apple-mail.png" alt=''/>
                                    <h4 className={css.link} ref={this.emailRef as React.RefObject<HTMLDivElement>}
                                        onClick={() => {
                                            const el = document.createElement('textarea');
                                            el.value = 'med.yessine.b.k@gmail.com';
                                            document.body.appendChild(el);
                                            el.select();
                                            document.execCommand('copy');
                                            document.body.removeChild(el);
                                            this.setState({open: true})
                                        }}>med.yessine.b.k@gmail.com</h4>
                                    <Snackbar anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                                              open={this.state.open} autoHideDuration={3000}
                                              onClose={(e, reason) => {
                                                  if (reason !== 'clickaway')
                                                      this.setState({open: false})
                                              }}>
                                        <Alert severity="success">Copied!</Alert>
                                    </Snackbar>
                                </div>
                                <div>
                                    <img src="https://img.icons8.com/clouds/50/000000/github.png" alt=''/>
                                    <a className={css.link} href='https://github.com/adhess'
                                       rel="noopener noreferrer" target='_blank'>Github</a>
                                </div>
                                <div>
                                    <img src="https://img.icons8.com/clouds/50/000000/linkedin.png" alt=''/>
                                    <a className={css.link} href='https://www.linkedin.com/in/med-yassine-b-k/'
                                       rel="noopener noreferrer"
                                       target='_blank'>LinkedIn</a>
                                </div>
                                <div>
                                    <img src={cg} alt=''/>
                                    <a className={css.link}
                                       href='https://www.codingame.com/profile/ae7aa83eadad7d80dd6897ae60ecbeb01563542'
                                       rel="noopener noreferrer"
                                       target='_blank'>Codingame</a>
                                </div>
                                <div className={css.language}>
                                    <h3>Languages</h3>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: "center"}}>
                                        <h4>Arabic</h4>
                                        :
                                        <Rating className={css.rating} value={4.5} precision={0.5} readOnly/>
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: "center"}}>
                                        <h4>English</h4>
                                        :
                                        <Rating className={css.rating} value={4} precision={0.5} readOnly/>
                                    </div>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: "center"}}>
                                        <h4>French</h4>
                                        :
                                        <Rating className={css.rating} value={3.5} precision={0.5} readOnly/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img className={css.whiteMask} src={HeaderWhiteMask} onLoad={this.onFinishLoading.bind(this)}
                         alt=''/>
                </div>
            </div>
        );
    }

    onFinishLoading() {
        if (this.state.nbImgToLoad <= 1) {
            document.getElementById('nb-global-spinner')?.remove();
        } else {
            this.setState((state: { nbImgToLoad: number }) => ({nbImgToLoad: state.nbImgToLoad - 1}));
        }
    }


}

// class Termynal {
//     container: Element| any;
//     pfx: string;
//     startDelay: any;
//     typeDelay: any;
//     lineDelay: any;
//     progressLength: any;
//     progressChar: any;
//     progressPercent: any;
//     cursor: any;
//     lineData: any;
//     lines: any[] = [];
//
//     /**
//      * Construct the widget's settings.
//      * @param {(string|Node)=} container - Query selector or container element.
//      * @param {Object=} options - Custom settings.
//      * @param {string} options.prefix - Prefix to use for data attributes.
//      * @param {number} options.startDelay - Delay before animation, in ms.
//      * @param {number} options.typeDelay - Delay between each typed character, in ms.
//      * @param {number} options.lineDelay - Delay between each line, in ms.
//      * @param {number} options.progressLength - Number of characters displayed as progress bar.
//      * @param {string} options.progressChar – Character to use for progress bar, defaults to █.
//      * @param {number} options.progressPercent - Max percent of progress.
//      * @param {string} options.cursor – Character to use for cursor, defaults to ▋.
//      * @param {Object[]} lineData - Dynamically loaded line data objects.
//      * @param {boolean} options.noInit - Don't initialise the animation.
//      */
//     constructor(container = '#termynal', options:any = {}) {
//         console.log("constructor: okay")
//         this.container = (typeof container === 'string') ? document.querySelector(container) : container;
//         this.pfx = `data-${options.prefix || 'ty'}`;
//         this.startDelay = options.startDelay
//             || parseFloat(this.container.getAttribute(`${this.pfx}-startDelay`)) || 600;
//         this.typeDelay = options.typeDelay
//             || parseFloat(this.container.getAttribute(`${this.pfx}-typeDelay`)) || 90;
//         this.lineDelay = options.lineDelay
//             || parseFloat(this.container.getAttribute(`${this.pfx}-lineDelay`)) || 1500;
//         this.progressLength = options.progressLength
//             || parseFloat(this.container.getAttribute(`${this.pfx}-progressLength`)) || 40;
//         this.progressChar = options.progressChar
//             || this.container.getAttribute(`${this.pfx}-progressChar`) || '█';
//         this.progressPercent = options.progressPercent
//             || parseFloat(this.container.getAttribute(`${this.pfx}-progressPercent`)) || 100;
//         this.cursor = options.cursor
//             || this.container.getAttribute(`${this.pfx}-cursor`) || '▋';
//         this.lineData = this.lineDataToElements(options.lineData || []);
//         if (!options.noInit) this.init()
//     }
//
//     /**
//      * Initialise the widget, get lines, clear container and start animation.
//      */
//     init() {
//         // Appends dynamically loaded lines to existing line elements.
//         this.lines = [...this.container.querySelectorAll(`[${this.pfx}]`)].concat(this.lineData);
//
//         /**
//          * Calculates width and height of Termynal container.
//          * If container is empty and lines are dynamically loaded, defaults to browser `auto` or CSS.
//          */
//         const containerStyle = getComputedStyle(this.container);
//         this.container.style.width = containerStyle.width !== '0px' ?
//             containerStyle.width : undefined;
//         this.container.style.minHeight = containerStyle.height !== '0px' ?
//             containerStyle.height : undefined;
//
//         this.container.setAttribute('data-termynal', '');
//         this.container.innerHTML = '';
//         this.start();
//     }
//
//     /**
//      * Start the animation and rener the lines depending on their data attributes.
//      */
//     async start() {
//         console.log("start: okay")
//         await this._wait(this.startDelay);
//
//         for (let line of this.lines) {
//             const type = line.getAttribute(this.pfx);
//             const delay = line.getAttribute(`${this.pfx}-delay`) || this.lineDelay;
//
//             if (type == 'input') {
//                 line.setAttribute(`${this.pfx}-cursor`, this.cursor);
//                 await this.type(line);
//                 await this._wait(delay);
//             }
//
//             else if (type == 'progress') {
//                 await this.progress(line);
//                 await this._wait(delay);
//             }
//
//             else {
//                 this.container.appendChild(line);
//                 await this._wait(delay);
//             }
//
//             line.removeAttribute(`${this.pfx}-cursor`);
//         }
//     }
//
//     /**
//      * Animate a typed line.
//      * @param {Node} line - The line element to render.
//      */
//     async type(line: any) {
//         console.log("type: okay")
//         const chars = [...line.textContent];
//         const delay = line.getAttribute(`${this.pfx}-typeDelay`) || this.typeDelay;
//         line.textContent = '';
//         this.container.appendChild(line);
//
//         for (let char of chars) {
//             await this._wait(delay);
//             line.textContent += char;
//         }
//     }
//
//     /**
//      * Animate a progress bar.
//      * @param {Node} line - The line element to render.
//      */
//     async progress(line: any) {
//         console.log("progress: okay")
//         const progressLength = line.getAttribute(`${this.pfx}-progressLength`)
//             || this.progressLength;
//         const progressChar = line.getAttribute(`${this.pfx}-progressChar`)
//             || this.progressChar;
//         const chars = progressChar.repeat(progressLength);
//         const progressPercent = line.getAttribute(`${this.pfx}-progressPercent`)
//             || this.progressPercent;
//         line.textContent = '';
//         this.container.appendChild(line);
//
//         for (let i = 1; i < chars.length + 1; i++) {
//             await this._wait(this.typeDelay);
//             const percent = Math.round(i / chars.length * 100);
//             line.textContent = `${chars.slice(0, i)} ${percent}%`;
//             if (percent>progressPercent) {
//                 break;
//             }
//         }
//     }
//
//     /**
//      * Helper function for animation delays, called with `await`.
//      * @param {number} time - Timeout, in ms.
//      */
//     _wait(time: any) {
//         console.log("_wait: okay")
//         return new Promise(resolve => setTimeout(resolve, time));
//     }
//
//     /**
//      * Converts line data objects into line elements.
//      *
//      * @param {Object[]} lineData - Dynamically loaded lines.
//      * @param {Object} line - Line data object.
//      * @returns {Element[]} - Array of line elements.
//      */
//     lineDataToElements(lineData: any) {
//         console.log("lineDataToElements: okay")
//         return lineData.map((line: any) => {
//             let div = document.createElement('div');
//             div.innerHTML = `<span ${this._attributes(line)}>${line.value || ''}</span>`;
//
//             return div.firstElementChild;
//         });
//     }
//
//     /**
//      * Helper function for generating attributes string.
//      *
//      * @param {Object} line - Line data object.
//      * @returns {string} - String of attributes.
//      */
//     _attributes(line: any) {
//         console.log("_attributes: okay")
//         let attrs = '';
//         for (let prop in line) {
//             attrs += this.pfx;
//
//             if (prop === 'type') {
//                 attrs += `="${line[prop]}" `
//             } else if (prop !== 'value') {
//                 attrs += `-${prop}="${line[prop]}" `
//             }
//         }
//
//         return attrs;
//     }
// }

const ParticlesWrapper = () => {
    const params = {
        particles: {
            number: {
                value: 80,
                density: {
                    enable: true,
                    value_area: 800
                }
            },
            color: {
                value: "#63c9dc"
            },
            shape: {
                type: "circle",
                stroke: {
                    width: 0,
                    color: "#000000"
                },
                polygon: {
                    nb_sides: 5
                },
            },
            opacity: {
                value: 0.5,
                random: true,
                anim: {
                    enable: false,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: false
                }
            },
            size: {
                value: 2,
                random: true,
                anim: {
                    enable: false,
                    speed: 40,
                    size_min: 0.1,
                    sync: false
                }
            },
            line_linked: {
                enable: true,
                distance: 150,
                color: "#21c0dc",
                opacity: 0.4,
                width: 1
            },
            move: {
                direction: "none",
                enable: true,
                outMode: "bounce",
                random: false,
                speed: 3,
                straight: false,
            },
        }
    };

    // @ts-ignore
    return <Particles className={css.particles} params={params}/>;
}